module.exports = __webpack_public_path__ + "static/img/8.70b8979.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/8.png
// module id = 9mEq
// module chunks = 0